export default __webpack_public_path__ + "locales/es-MX/translation.json";